/* eslint-disable */
import axios from '../index'

const getAll = () => {
  return axios.get('contact')
}

const api = { getAll }


export default api;